import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=cc62f4de&scoped=true&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=cc62f4de&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc62f4de",
  null
  
)

export default component.exports